import { BeconCommonTypes, Optional } from "@becon-team/becon-fe-lib/my-types";

/** 인종적인 질문 감추기 */
export const checkHideRaceInquiry = (region: Optional<BeconCommonTypes.Region>) => {
  if (!region) return false;

  const countries: BeconCommonTypes.Region[] = ["CN" /* 중국 */, "JP" /* 일본 */, "KR" /* 한국 */, "VN" /* 베트남 */];

  return countries.includes(region);
};
